import { useTranslation } from 'react-i18next';
import './About.css';

const PRINCIPLES = ['live', 'tenant', 'focused'] as const;

export function About() {
  const { t } = useTranslation();

  return (
    <section id="about" className="section section--soft">
      <div className="container">
        <div className="about-grid">
          <div className="about-grid__lead">
            <span className="eyebrow">{t('about.eyebrow')}</span>
            <h2>{t('about.title')}</h2>
            <p className="lead about-grid__body">{t('about.body')}</p>
          </div>
          <ul className="principles">
            {PRINCIPLES.map((key) => (
              <li key={key} className="principle">
                <span className="principle__num" aria-hidden="true" />
                <div>
                  <h4 className="principle__title">{t(`about.principles.${key}.title`)}</h4>
                  <p className="principle__body">{t(`about.principles.${key}.body`)}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
